import React from 'react';
import BaseList from 'components/lists/BaseList';
import { useAccessLog } from 'hooks/logs';

function ListEquipmentColor(props) {
  useAccessLog('Acesso ao cadastro de cores');
  const { match } = props;
  return (
    <BaseList
      columns={[
        { value: row => row.name, label: 'Nome', sort: 'name' },
      ]}
      genericSearchFields={[
        { label: 'Nome', name: 'name' },
      ]}
      basePath="equipment-color"
      title="Lista de Cores"
      addButtonText="Cadastrar Cor"
      addUrl={`${match.path}/novo`}
    />
  );
}

export default ListEquipmentColor;
